
  /**
   * Extracts the Id from a Youtube Video Url
   *
   * @see http://stackoverflow.com/questions/3452546/javascript-regex-how-to-get-youtube-video-id-from-url/8260383#8260383
   *
   * @param  {string} youTubeUrl YouTube Url
   * @return {string}            YouTube Video Id
   */
  export default function(youTubeUrl) {
    var pattern = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = youTubeUrl.match(pattern);
    if (match && match[7].length === 11) {
      return match[7];
    } else {
      console.error(new Error('Wrong YouTube URL "' + youTubeUrl + '"'));
    }
  };
